import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the configuration parameters (50-api/reference.md): all of them at once, they are a handful.

const parameters = api.reference.parameters;

export type ConfigParameter = InferResponseType<typeof parameters.$get, 200>["items"][number];

const keys = { all: ["config-parameters"] as const };

export const parameterQueries = {
  ...keys,

  list: () =>
    queryOptions({
      queryKey: [...keys.all, "list"],
      queryFn: async ({ signal }) => (await unwrap(parameters.$get({}, { init: { signal } }))).items,
    }),
};
